import React from 'react';
import { Skill } from '../../../../../types/resume';
import { Trash2 } from 'lucide-react';
import Input from '../../../../ui/Input';

interface Props {
  skill: Skill;
  onUpdate: (id: string, updates: Partial<Skill>) => void;
  onRemove: (id: string) => void;
}

const skillLevels: Skill['level'][] = [
  'beginner',
  'intermediate',
  'advanced',
  'expert'
];

export default function SkillItem({ skill, onUpdate, onRemove }: Props) {
  return (
    <div className="bg-white p-4 rounded-lg shadow-sm border border-gray-100 hover:border-teal-200 transition-colors">
      <div className="flex-1">
        <Input
          value={skill.name}
          onChange={(e) => onUpdate(skill.id, { name: e.target.value })}
          placeholder="e.g. JavaScript, Leadership, Adobe Photoshop"
          className="mb-2"
        />
        
        <select
          value={skill.level}
          onChange={(e) => onUpdate(skill.id, { level: e.target.value as Skill['level'] })}
          className="w-full px-3 py-2 text-sm border rounded-lg focus:ring-2 focus:ring-teal-500 focus:border-teal-500 border-gray-300"
        >
          {skillLevels.map(level => (
            <option key={level} value={level}>
              {level === 'beginner' ? 'Basic' :
               level === 'intermediate' ? 'Intermediate' :
               level === 'advanced' ? 'Advanced' :
               'Expert'}
            </option>
          ))}
        </select>
      </div>
      <button
        onClick={() => onRemove(skill.id)}
        className="ml-2 p-1 text-gray-400 hover:text-red-500 rounded-full hover:bg-red-50 transition-colors"
        title="Remove skill"
      >
        <Trash2 className="h-4 w-4" />
      </button>
    </div>
  );
}